import * as PIXI from "pixi.js";
import { SwitcherButtonStyle } from "../../../types/Interface";


export default class SwitcherButtonRenderer {
  drawButtonBg(buttonBg: PIXI.Graphics, buttonStyle: SwitcherButtonStyle, color: number, updateBg: boolean, border: boolean) {
    updateBg && buttonBg
      .clear()
      .roundRect(
        -buttonStyle.width / 2,
        -buttonStyle.height / 2,
        buttonStyle.width,
        buttonStyle.height,
        buttonStyle.borderRadius || 10
      )
      .fill(color);

    (typeof border === "undefined" || border) && buttonBg.stroke({ color: 0x000000, width: 3 });
  }
  static generateText(label: string, fontSize: number, fill: number) {
    const text = new PIXI.Text({ text: label });
    text.style = {
      fill,
      fontSize,
      fontWeight: "500"
    }
    text.anchor.set(.5);
    return text;
  }
}